import { useMemo, useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

/**
 * Custom hook that encapsulates all the business logic for DetailsView
 */
export function useDetailsViewLogic({
  isFetching,
  isWaitingForConf,
  isFetchingProducts,
  publicDataMap,
  publicData,
  openResourcePage,
}) {
  const [syncedLoading, setSyncedLoading] = useState(false);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  // Sync loading state with various fetching states
  useEffect(() => {
    if (isWaitingForConf || isFetchingProducts) {
      setSyncedLoading(true);
    }
    if (!isFetching) {
      setSyncedLoading(false);
    }
  }, [isWaitingForConf, isFetchingProducts, isFetching]);

  const showContactData = useMemo(() => {
    const contact = publicData?.contact;
    return contact?.name || contact?.email || contact?.mobile || contact?.phone;
  }, [publicData?.contact]);

  const showResourceSelect = useMemo(() => {
    return (
      openResourcePage &&
      isSmallScreen &&
      publicDataMap &&
      Object.keys(publicDataMap)?.length > 1
    );
  }, [isSmallScreen, openResourcePage, publicDataMap]);

  const showDetails = useMemo(() => {
    return publicData?.resource?.uuid !== 'all-option';
  }, [publicData?.resource?.uuid]);

  return {
    syncedLoading,
    showContactData,
    showResourceSelect,
    showDetails,
    isSmallScreen,
  };
}
